import React, { useMemo, useCallback } from 'react';
import Select from 'react-select';

const gearOptions = [
    { value : 'No special gear required', label: 'No special gear required' },
    { value : 'Full Size Spare Tire', label: 'Full Size Spare Tire' },
    { value: 'Winch', label: 'Winch' },
    { value: 'Armor/rock sliders', label: 'Armor/rock sliders' },
    { value: 'Extra fuel', label: 'Extra fuel' },
    { value: '4-low', label: '4-low' },
    { value: 'Off road tires', label: 'Off road tires' },
];

const GearSelect = ({ selectedGear, setSelectedGear }) => {
    const handleChange = useCallback((selectedOptions) => {
        const newValues = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
        setSelectedGear(newValues);
    }, [setSelectedGear]);

    // Memoize the value calculation to prevent unnecessary recalculations
    const value = useMemo(() => {
        // Ensure selectedGear is always an array
        const gear = Array.isArray(selectedGear) ? selectedGear : [];
        return gearOptions.filter(opt => gear.includes(opt.value));
    }, [selectedGear]);

    return (
        <div style={{marginBottom: '1rem'}}>
            <label className="block mb-1 text-sm font-bold">Required Gear (select one or more)</label>
            <Select
                options={gearOptions}
                isMulti
                value={value}
                onChange={handleChange}
                placeholder="Select required gear"
                // Add a key to help React identify this component
                key="gear-select"
            />
        </div>
    );
};

export default GearSelect;